
    import {
      withCompInfo,
      createComponentMapperModel,
    } from '@wix/editor-elements-integrations';

    const props = withCompInfo<any, any>()(
      ['compData', 'compStylableClass'],
      ({ compData, compStylableClass }) => {
        return {
          ...{"items":[{"value":"choice_01","label":"Choice 1","disabled":false,"isDefault":false},{"value":"choice_02","label":"Choice 2","disabled":false,"isDefault":false},{"value":"choice_03","label":"Choice 3","disabled":false,"isDefault":false}],"activeTabIndex":0},
          ...compData,
          className: compStylableClass
        };
      },
    );

    export default createComponentMapperModel({
      props,
    });
  